import Vue from 'vue';
import { Module } from 'vuex';
import { RootState } from '@/types/store';
import TeamApply from '@/models/teamApply';
import MonitorApply from '@/models/monitorApply';

declare global {
    interface MonitorApplyStatus {
        applied: boolean;
        contract_signed: boolean;
        extra_info_filled: boolean;
        ever_became_monitor: boolean;
        // 最新邀请人id
        referrer: number;
        referrer_nickname: string;
        referrer_avatar: string;
        status: 'pending' | 'accepted' | 'rejected';
    }
}

export interface CreateTeamState {
    /** 队长申请数据 */
    monitorApply: MonitorApply | null;
    /** 队长申请状态 */
    monitorApplyStatus: MonitorApplyStatus | null;
    /** 如果用户已经创建过战队此字段为创建信息，否则返回null */
    teamApply: Monitor.TeamApply | null;
}

const m: Module<CreateTeamState, RootState> = {
    namespaced: true,
    state: () => ({
        monitorApply: null,
        monitorApplyStatus: null,
        teamApply: new TeamApply(),
    }),
    mutations: {
        /**
         * 记录队长申请状态
         */
        setMonitorApplyStatus(state, status: MonitorApplyStatus) {
            state.monitorApplyStatus = status;
        },
        /**
         * 记录申请
         * @param {} apply 申请数据
         */
        setTeamApply(state, apply) {
            state.teamApply = apply;
        },
    },
    actions: {
        /**
         * 检查队长申请状态
         */
        async checkMonitorApply({ state, commit }, { activityId }) {
            const response = await Vue.axios.get('/api/v1/monitor_apply/check', {
                params: {
                    activity_id: activityId,
                },
            });
            const rdata = response.data;
            if (rdata.status === 0) {
                commit('setMonitorApplyStatus', rdata.data);
            }
            return rdata;
        },
        /**
         * 提交队长额外信息
         */
        async submitMonitorInfo({ state, commit }, { activityId, predicatedMemberCount, referrer, referrerMobile }) {
            const response = await Vue.axios.post('/api/v1/monitor_apply/create', {
                activity_id: activityId,
                predicted_member_count: predicatedMemberCount,
                referrer,
                referrer_mobile: referrerMobile,
            });
            return response.data;
        },
        /**
         * 申请创建战队
         * @param {} data 数据
         */
        async applyTeam(context, { activityId, apply }: { activityId: any; apply: TeamApply }) {
            const response = await Vue.axios.post('/api/v1/monitor/create_team', {
                activity_id: activityId,
                ...apply.toRaw(),
            });
            const rdata = response.data;
            return rdata;
        },
    },
};
export default m;
